import { render, staticRenderFns } from "./parts-locations-sms-email-card-edit.vue?vue&type=template&id=3d0567c0&scoped=true&"
import script from "./parts-locations-sms-email-card-edit.vue?vue&type=script&lang=js&"
export * from "./parts-locations-sms-email-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations-sms-email-card-edit.vue?vue&type=style&index=0&id=3d0567c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0567c0",
  null
  
)

export default component.exports